import { getWebApiUrl, httpClient } from "@utils";

import { BetSlipResultExtended } from "@api-types/bet-slip/BetSlipResultExtended";
import { getApiRequestContext } from "@utils/api-config";
import { ApiRequestContextData } from "@utils/api-config/types";
import { getMvcRequestHeaders } from "@utils/api-config/getMvcRequestHeaders";

export class SlipApiService {
	static baseUrl() {
		return `${getWebApiUrl()}/api/slip`;
	}

	static getMvcRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getMvcRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async delay(): Promise<{ value: number; level: number }> {
		const context = getApiRequestContext();

		return await httpClient.get(
			`${this.baseUrl()}/delay`,
			this.getMvcRequestHeaders(context)
		);
	}

	static async getSlipByEncryptedBetSlipNumber(
		encryptedBetSlipNumber: string
	): Promise<BetSlipResultExtended> {
		const context = getApiRequestContext();

		return await httpClient.get(
			`${this.baseUrl()}/check-bet-slip/${encryptedBetSlipNumber}`,
			this.getMvcRequestHeaders(context)
		);
	}
}
